"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FetchType = void 0;
const FetchType = exports.FetchType = {
  JSON_FORMAT: "application/json",
  OCTET_STREAM_FORMAT: "application/octet-stream",
  MULTIPART_FORMAT: "multipart/form-data"
};